// ABOUTME: Notification email template view on the warehouse Email settings page.
// ABOUTME: Thin wrapper around the shared EmailTemplateEditor; one required shortcode ({{content}}), no subject.

import EmailTemplateEditor from "../../../../../components/global/EmailTemplates/EmailTemplateEditor";
import { UserPrivileges } from "../../../../../utils/permissions";

const Notifications = (props) => (
    <EmailTemplateEditor
        {...props}
        type="notification"
        titleKey="notifications_email"
        managePrivileges={[UserPrivileges.SETTINGS_GENERAL, UserPrivileges.SETTINGS_ALL]}
        showSubject={false}
    />
);

export default Notifications;
